import { createContext, useEffect, useReducer } from "react";
import AuthReducer from "./AuthReducer";

const INITIAL_STATE = {
  currentUser: JSON.parse(localStorage.getItem("user")) || null,
};

export const AuthContext = createContext(INITIAL_STATE);

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);

  const setSessionCookie = () => {
    document.cookie = "loginstatus=loggedin; path=/"; 
  };

  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
  };

  // 🚀 Auto-logout if cookie is missing
  useEffect(() => {
    if (!getCookie("loginstatus")) {
      localStorage.removeItem("user");
      dispatch({ type: "LOGOUT" });
    }
  }, [dispatch]);

  // 🚀 Save user and refresh cookie when logged in
  useEffect(() => {
    if (state.currentUser) {
      localStorage.setItem("user", JSON.stringify(state.currentUser));
      setSessionCookie();
    } else {
      localStorage.removeItem("user");
    }
  }, [state.currentUser]);


    // ✅ Handle inactivity logout (30 mins)
    useEffect(() => {
      if (!state.currentUser) return;
  
      let inactivityTimer;
      const resetTimer = () => {
        clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(() => {
          alert("Logged out due to inactivity");
          sessionStorage.removeItem("user"); // ⬅ Clear sessionStorage
          dispatch({ type: "LOGOUT" });
        }, 30 * 60 * 1000);
      };
  
      const events = ["mousemove", "keydown", "scroll", "click"];
      events.forEach((event) => window.addEventListener(event, resetTimer));
  
      resetTimer();
      return () => {
        events.forEach((event) => window.removeEventListener(event, resetTimer));
        clearTimeout(inactivityTimer);
      };
    }, [state.currentUser, dispatch]);

  return (
    <AuthContext.Provider value={{ currentUser: state.currentUser, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};

